export default "__VITE_ASSET__BZjReVK4__"